


































































import {
  computed,
  defineComponent, onMounted, Ref, ref,
} from '@vue/composition-api';
import { useRouter, useFormat } from '@ideavivat/vivat-2';
import PrettyCheck from 'pretty-checkbox-vue/check';

import {
  getConfigs,
  getUsersStats,
  updateWebsiteConfig,
} from '@/api/index';
import { tokenName } from '@/useAuth';

import CommonModalWithPreset from '@/components/CommonModalWithPreset.vue';

const PUBLIC_HOST = process.env.VUE_APP_PUBLIC_HOST || '';

const Dashboard = defineComponent({
  components: {
    PrettyCheck,
    CommonModalWithPreset,
  },
  setup() {
    const successModal = ref(null);
    const stats: Ref<any> = ref({});
    const features: Ref<any> = ref({
      loginEnable: { value: false, label: 'อนุญาตให้ Login', description: '* User สามารถ Login เข้าระบบ (หรือกรอก Code)' },
      registerEnable: { value: false, label: 'อนุญาตให้สมัครสมาชิก', description: '' },
      landingEnablePage: { value: false, label: 'เปิดให้เข้า Landing Page' },
      landingEnableLiveNowBar: { value: false, label: 'Live Now Badge', description: '* แถบสีแดง ๆ บนสุดของเว็บไซต์' },
    });

    const computedFeatureInput = computed(() => {
      const result = {};
      Object.entries(features.value).forEach(([key, value]: any[]) => {
        (result as any)[key] = value?.value;
      });
      return result;
    });

    async function updateConfig(name: string, status: boolean) {
      (features.value as any)[name].value = !status;
    }

    async function callUpdateWebsiteConfig(data: any) {
      const result = await updateWebsiteConfig(data, 'all');
      if (result !== '') {
        features.value.landingEnablePage = (await getConfigs('landing')).features.landingEnablePage;
        features.value.landingEnableLiveNowBar = (await getConfigs('landing')).features.landingEnableLiveNowBar;
        features.value.loginEnable = (await getConfigs('login')).features.loginEnable;
        features.value.registerEnable = (await getConfigs('register')).features.registerEnable;
        (successModal.value as any).compose({ action: 'แก้ไข', entity: 'การตั้งค่า เรียบร้อย' });
      }
    }
    async function submitUpdateConfig() {
      await callUpdateWebsiteConfig(computedFeatureInput.value);
    }

    async function callGetConfigs(force = false) {
      const landing = (await getConfigs('landing', force));
      const login = (await getConfigs('login', force));
      const register = (await getConfigs('register', force));
      (features.value as any).landingEnablePage.value = landing.features.landingEnablePage?.value || false;
      (features.value as any).landingEnableLiveNowBar.value = landing.features.landingEnableLiveNowBar?.value;
      (features.value as any).loginEnable.value = login.features.loginEnable?.value;
      (features.value as any).registerEnable.value = register.features.registerEnable?.value;
    }
    onMounted(async () => {
      await callGetConfigs();
      stats.value = await getUsersStats();
    });

    function redirectToPublicSite() {
      if (PUBLIC_HOST) {
        window.open(`${PUBLIC_HOST}/entry?t=admin|${localStorage.getItem(tokenName)}`, '_blank');
        return;
      }
      const publicUrl = (window.location.host).replace('-admin', '');
      window.open(`https://${publicUrl}${publicUrl.charAt(publicUrl.length - 1) === '/' ? '' : '/'}entry?t=admin|${localStorage.getItem(tokenName)}`, '_blank');
    }

    return {
      displayDate: (a: string) => useFormat.date(a).displayShortThaiDateTime(),
      stats,
      successModal,

      features,
      submitUpdateConfig,
      updateConfig,

      redirectToPublicSite,
    };
  },
});

export default Dashboard;
